import AddPayoutSliderAdminPartial from "../../../../partials/admin/menus/vendors/add-payout-slider.admin.partial";

export default function AddPayoutSliderAdminScreen() {
  return <AddPayoutSliderAdminPartial />;
}
